import $ from "jquery";
import 'jquery-validation';
import { Modal } from 'flowbite';
import { getRequest } from "../utilities/Util.js";
import { getCookie } from "../global/cookie.js"
import { populateCountries, populateStates } from "../salesforce/countries.js";
const boatNamesAPIURL = `${location.origin}/umbraco/api/boats/GetAllBoatNames`;


/**
 * returs data safely parsed
 * @param {string|undefined} s
 * @param {any} fallback
 * @returns {any}
 */
function safeParse(s, fallback) {
    try { return s ? JSON.parse(s) : fallback; } catch { return fallback; }
}

/**
 * Returns the first string that has Data
 * @param {unknown} a
 * @param {unknown} b
 */
function coalesceHtml(a, b) {
    if (stringHasContent(a)) return String(a);
    if (stringHasContent(b)) return String(b);
    return "";
}

/**
 * Returns true if its string and has content
 * @param {unknown} string
 */
function stringHasContent(string) {
    return typeof string === "string" && string.trim().length > 0;
}

// options with default values
const modalOptions = {
    placement: 'center-center',
    backdrop: 'dynamic',
    backdropClasses:
        'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-2',
    closable: true,
    onHide: () => {
        location.reload();
    },
    onShow: () => {
        console.log('modal is shown');
    },
    onToggle: () => {
        console.log('modal has been toggled');
    },
};
// instance options object 
const modalInstanceOptions = {
    /* id: 'single-salesforce-form-modal',*/
    override: true
};

async function populateBoats(boatsElementId) {
    //given the id of the <select> tag as function argument, it inserts <option> tags
    for (var j = 0; j < document.getElementsByClassName(boatsElementId).length; j++) {
        var boatElement = document.getElementsByClassName(boatsElementId)[j];
        boatElement.length = 0;
        boatElement.options[0] = new Option("Select A Model", "-1");
        boatElement.selectedIndex = 0;
        var boatsDropdownData = await getRequest(boatNamesAPIURL);

        $.each(boatsDropdownData, function (index, boat) {
            var option = new Option(boat, boat);
            boatElement.append(option);
        });

    }
}

$(function () {
    formvalidcheck();
});


/**
 * Adds the URL Parameter to existing URL and reloads the page
 * @param {String} URLParameter string to add to the URL
 */
function redirectAfterFormSubmission(URLParameter) {
    let submitFlag = getUrlParameter(URLParameter);
    if (submitFlag === false) {
        if (window.location.href.includes("?")) {
            window.location = window.location.href + "&" + URLParameter + "=1";
        } else {
            window.location = window.location.href + "?" + URLParameter + "=1";
        }
    } else {
        location.reload();
    }
}

//Redirects to the same page but adds a "submit=1" flag to the existing URL
function redirectAsSubmit() {
    $("#email-signup")[0].reset();
    $("#email-signup-success-modal").show();
}

if (window.location.href.includes("submit=1")) {
    $("#email-signup-success-modal").show();
}

$("#email-signup-success-modal-toggle-button").on("click", function () {
    $("#email-signup-success-modal").hide();
});

/**
* Generate reCaptcha Token
*
* @param {FormData} reCaptchaTokenSiteKeyInput recapthca Site Key Element.
*/
export async function retrieveRecaptchaToken(form) {
    var reCAPTCHA_site_key = form.querySelector(".recaptcha_site_key");
    if (!reCAPTCHA_site_key) return null;

    var reCAPTCHA_site_key_value = reCAPTCHA_site_key.value?.trim();
    if (!reCAPTCHA_site_key_value) return null;

    return new Promise((resolve) => {
        grecaptcha.ready(function () {
            grecaptcha.execute(reCAPTCHA_site_key_value, { action: 'submit' }).then(function (token) {
                return resolve(token);
            });
        });
    });

}

//Alert error message on request
function alertError(form, xhr) {
    //console.log(form);
    console.log(xhr);
    alert("An unexpected error has occurred.");
}

const successModal = document.getElementById("success-modal");
const successPanel = document.getElementById("success-panel");
const successClose = document.getElementById("success-close");
const successMsgHeader = document.getElementById("success-header-message");
const successMsgText = document.getElementById("success-text-message");
const successMsgMedia = document.getElementById("success-modal-image");

function triggerSuccessModal(form, data, responseData) {
    try {
        const titleText = coalesceHtml(responseData.titleHtml, successMsgHeader.textContent)
        const subtitleText = coalesceHtml(responseData.subtitleHtml, successMsgText.textContent)
        const mediaData = responseData.media;

        if (titleText) successMsgHeader.innerHTML = titleText;
        if (subtitleText) successMsgText.innerHTML = subtitleText;
        if (mediaData) { successMsgMedia.src = mediaData.url; }
        else {
            successMsgMedia.classList.add("hidden");
        }

        successModal.classList.remove("hidden");
        successModal.classList.add("grid");
        successModal.setAttribute("aria-hidden", "false");
        requestAnimationFrame(() => {
            successPanel.classList.remove("opacity-0", "translate-y-4");
            successPanel.classList.add("opacity-100", "translate-y-0");
        });
        SuccessModalDismiss();
        setTimeout(() => successClose?.focus(), 60);
    } catch (e) {
        console.error("Success Modal open failed", e);
    }
}

export function SuccessModalDismiss() {
    if (successModal.__bound) return;
    successModal.addEventListener("click", e => {
        if (e.target === successModal) closeSuccessYouModal();
    }, { passive: true });
    document.addEventListener("keydown", e => {
        if (e.key === "Escape") closeSuccessYouModal();
    }, { passive: true });
    successClose?.addEventListener("click", closeSuccessYouModal);
    successModal.__bound = true;
}
export function closeSuccessYouModal() {
    try {
        successPanel.classList.remove("opacity-100", "translate-y-0");
        successPanel.classList.add("opacity-0", "translate-y-4");
        setTimeout(() => {
            successModal.classList.add("hidden");
            successModal.classList.remove("grid");
            successModal.setAttribute("aria-hidden", "true");
        }, 180);
        location.reload();
    } catch (e) {
        console.error("Success close failed", e);
    }
}

async function salesforceFormSubmissionHandler(form, success_callback, error_callback) {
    $(form).find("button[type='submit']").attr("disabled", true); //Disable submit button
    addUTMParameters(form);

    const reCaptchaToken = await retrieveRecaptchaToken(form);
    if (reCaptchaToken) {
        const tokenInput = form.querySelector(".recaptcha_token");
        if (tokenInput) tokenInput.value = reCaptchaToken;
    }
    submitFormAsJson(form, success_callback, error_callback);
}

function submitFormAsJson(form, success_callback, error_callback) {
    const url = form.action;
    const method = form.method.toUpperCase();
    var formData = new FormData(form)
    var payload = JSON.stringify(Object.fromEntries(formData));

    fetch(url, {
        method,
        headers: {
            "Content-Type": "application/json"
        },
        body: payload
    })
        .then(response => {
            if (!response.ok) {
                // Treat any HTTP error status as a failure
                throw response;
            }
            return response.json();
        })
        .then(result => {
            const formResponseData = form.closest(".salesforce-tab-content");
            const responseData = formResponseData ? {
                titleHtml: safeParse(formResponseData.dataset.responseTitle, ""),
                subtitleHtml: safeParse(formResponseData.dataset.responseSubtitle, ""),
                media: safeParse(formResponseData.dataset.responseMedia, null)
            } : {};

            if (typeof success_callback === "function") {
                success_callback(form, result, responseData)
            }
        })
        .catch(err => {
            if (typeof error_callback === "function") {
                error_callback(form, err);
            }
        });
}

function reloadPage() {
    location.reload();
}
function DealerLookupFormHandler(form, success_callback, error_callback) {
    $(form).find("input[type='submit']").attr("disabled", true); //Disable submit button
    var MC_CID = $("#mc_cid").val();
    addUTMParameters(form);
    $(form).find(".uuid").val(MC_CID);
    submitFormAsJson(form, success_callback, error_callback);
}

function DealerLookUpFormSuccessHandler(form, results) {
    var successModalTarget = "contact-dealer-success-modal";
    const successModalInstance = FlowbiteInstances.getInstance('Modal', successModalTarget);
    var formModalTarget = "contact-dealer-modal";
    const formModalInstance = FlowbiteInstances.getInstance('Modal', formModalTarget);
    formModalInstance.hide();
    successModalInstance.show();
}
function formvalidcheck() {
    $("#email-signup").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
        },
        //// Specify validation error messages
        messages: {
            FirstName: "First Name is required",
            LastName: "Last Name is required",
            Email: "Email is required",
            PostalCode: "Zipcode is required",
        },
        errorElement: "label",
        errorClass: "error",
        errorPlacement: function (error, element) {
            error.insertAfter(element);
            error.addClass("text-xs rte-balise-orange");
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            event.preventDefault();
            $("#email-signup-submit").attr("disabled", true);
            //$(form).find("input[type='submit']").attr("disabled", true);
            submitFormAsJson(form, redirectAsSubmit, alertError);
            return false;
        },
    });
    $("#gi_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            Subject__c: {
                required: true,
            },
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            Country: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
            //boat_serial_number__c: {
            //    required: true,
            //},
            //Comments__c: {
            //    required: true,
            //},
        },
        // Specify validation error messages
        messages: {
            FirstName: "First Name is required",
            LastName: "Last Name is required",
            Email: "Email is required",
            Subject__c: "Please select an option",
            Country: "Please select a country",
            PostalCode: "Zip is required",
            Phone: "Phone Number is required",
            boat_serial_number__c: "Please enter the boat serial #",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            salesforceFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });
    $("#brochure_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Street: {
                required: true,
            },
            City: {
                required: true,
            },
            State: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
            Boat_1_Interest__c: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First Name is required",
            LastName: "Last Name is required",
            Email: "Email is required",
            Street: "Address is required",
            City: "City is required",
            State: "State is required",
            PostalCode: "Zip is required",
            Phone: "Phone Number is required",
            Boat_1_Interest__c: "Please select a boat",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            salesforceFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });
    $("#tdr_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Street: {
                required: true,
            },
            City: {
                required: true,
            },
            State: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
            Boat_1_Interest__c: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First Name is required",
            LastName: "Last Name is required",
            Email: "Email is required",
            Street: "Address is required",
            City: "City is required",
            State: "State is required",
            PostalCode: "Zip is required",
            Phone: "Phone Number is required",
            Boat_1_Interest__c: "Please select a boat",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            salesforceFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });
    $("#requestquote_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            //Street: {
            //    required: true,
            //},
            //City: {
            //    required: true,
            //},
            //State: {
            //    required: true,
            //},
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
            Boat_1_Interest__c: {
                required: true,
            },
        },

        // Specify validation error messages
        messages: {
            FirstName: "First Name is required",
            LastName: "Last Name is required",
            Email: "Email is required",
            Street: "Address is required",
            City: "City is required",
            State: "State is required",
            PostalCode: "Zip is required",
            Phone: "Phone Number is required",
            Boat_1_Interest__c: "Please select a boat",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            salesforceFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });
    $("#launchLead_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Street: {
                required: true,
            },
            City: {
                required: true,
            },
            State: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First Name is required",
            LastName: "Last Name is required",
            Email: "Email is required",
            Street: "Address is required",
            City: "City is required",
            State: "State is required",
            PostalCode: "Zip is required",
            Phone: "Phone Number is required",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            var subjectDropdown = $(form).find(".Subject__c").val();
            $(form).find(".leadsource").val(subjectDropdown);
            $(launchLead_lead_source).val(subjectDropdown);
            salesforceFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });
    $("#cfr_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Phone: {
                required: true,
            },
            PostalCode: {
                required: true,
            }
        },

        // Specify validation error messages
        messages: {
            FirstName: "First Name is required",
            LastName: "Last Name is required",
            Email: "Email is required",
            PostalCode: "Zip is required",
            Phone: "Phone Number is required",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            salesforceFormSubmissionHandler(form, DealerLookUpFormSuccessHandler, alertError);
            event.preventDefault();
            return false;
        },
    });
}

function EmailSignUpSubmit() {
    event.preventDefault();
    if (region == "us") {
        var tab = "EmailSignUp";
        $.ajax({
            url: "/umbraco/surface/SalesForce/LoadPartial?name=" + tab,
            type: "GET",
            cache: false,
        })
            .done(function (result) {
                $("#email-signup-modal-body").empty();
                $("#email-signup-modal-body").html(result);
            })
            .done(function (result) {
                var EmailDesktop = $("#email-input-desktop").val();
                var EmailMobile = $("#email-input-mobile").val();
                if (EmailMobile != "") {
                    $("#email-signup_email").val(EmailMobile);
                } else {
                    $("#email-signup_email").val(EmailDesktop);
                }
                $("#email-input-desktop").val("");
                $("#email-input-mobile").val("");
                formvalidcheck();
            });
    } else {
        var tab = "FindADealer";
        $.ajax({
            url: "/umbraco/surface/SalesForce/LoadPartial?name=" + tab,
            type: "GET",
            cache: false,
        }).done(function (result) {
            $("#email-signup-modal-body").empty();
            $("#email-signup-modal-body").html(result);
        });
    }

    $("#email-signup-modal").modal("toggle");
}

//fetches all url parameters
function getAllUrlParams(url) {
    // get query string from url (optional) or window
    var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split("#")[0];

        // split our query string into its component parts
        var arr = queryString.split("&");

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split("=");

            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof a[1] === "undefined" ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === "string") paramValue = paramValue.toLowerCase();

            if (paramName != "") {
                // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                if (paramName.match(/\[(\d+)?\]$/)) {
                    // create key if it doesn't exist
                    var key = paramName.replace(/\[(\d+)?\]/, "");
                    if (!obj[key]) obj[key] = [];

                    // if it's an indexed array e.g. colors[2]
                    if (paramName.match(/\[\d+\]$/)) {
                        // get the index value and add the entry at the appropriate position
                        var index = /\[(\d+)\]/.exec(paramName)[1];
                        obj[key][index] = paramValue;
                    } else {
                        // otherwise add the value to the end of the array
                        obj[key].push(paramValue);
                    }
                } else {
                    // we're dealing with a string
                    if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (obj[paramName] && typeof obj[paramName] === "string") {
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }
                }
            }
        }
    }

    return obj;
}

function addUTMParameters(form) {
    var queryString = window.location.search;
    var fullquery = window.location.href;
    let utm_source = "";
    let utm_term = "";
    let utm_campaign = "";
    let utm_medium = "";
    let utm_content = "";
    var gclid_value = "";

    if ("URLSearchParams" in window) {
        const urlParams = new URLSearchParams(queryString);

        utm_source = urlParams.get("utm_source");
        utm_term = urlParams.get("utm_term");
        utm_campaign = urlParams.get("utm_campaign");
        utm_medium = urlParams.get("utm_medium");
        utm_content = urlParams.get("utm_content");
        gclid_value = urlParams.get("gclid");

        //update current values of UTM parameters to new cookie values
        loadUTMParameters();
    } else {
        utm_source = getAllUrlParams(fullquery).utm_source;
        utm_term = getAllUrlParams(fullquery).utm_term;
        utm_campaign = getAllUrlParams(fullquery).utm_campaign;
        utm_medium = getAllUrlParams(fullquery).utm_medium;
        utm_content = getAllUrlParams(fullquery).utm_content;
        gclid_value = getAllUrlParams(fullquery).gclid_value;

        //update current values of UTM parameters to new cookie values
        loadUTMParameters;
    }

    //pass cookie values
    if (utm_source == "" || utm_source == null) {
        utm_source = getCookie("utm_source");
    }
    if (utm_term == "" || utm_term == null) {
        utm_term = getCookie("utm_term");
    }
    if (utm_campaign == "" || utm_campaign == null) {
        utm_campaign = getCookie("utm_campaign");
    }
    if (utm_medium == "" || utm_medium == null) {
        utm_medium = getCookie("utm_medium");
    }
    if (utm_content == "" || utm_content == null) {
        utm_content = getCookie("utm_content");
    }
    if (gclid_value == "" || gclid_value == null) {
        gclid_value = getCookie("gclid");
    }
    $(form).find(".utm_source").val(utm_source);
    $(form).find(".utm_term").val(utm_term);
    $(form).find(".utm_campaign").val(utm_campaign);
    $(form).find(".utm_medium").val(utm_medium);
    $(form).find(".utm_content").val(utm_content);
    $(form).find(".gclid_value").val(gclid_value);
}

function EmailSignUpPopUp() {
    var queryString = window.location.search;
    var fullquery = window.location.href;
    let signup = "";
    let submit = "";
    if ("URLSearchParams" in window) {
        const urlParams = new URLSearchParams(queryString);
        signup = urlParams.get("email_signup");
        submit = urlParams.get("submit");
    } else {
        signup = getAllUrlParams(fullquery).email_signup;
        submit = getAllUrlParams(fullquery).submit;
    }

    if (signup == "1") {
        if (submit != "1") {
            EmailSignUpSubmit();
        }
    }
}

$(document).ready(function () {
    EmailSignUpPopUp();
    populateCountries("country");
    Array.from(document.getElementsByClassName("country")).forEach((countrySelect) => {
        const stateSelectId = countrySelect.dataset.stateId;
        if (stateSelectId != "") {
            const countrySelectId = countrySelect.id;
            countrySelect.addEventListener("change", () => {
                populateStates(countrySelectId, stateSelectId);
            });
        }
    });
    populateBoats("boats-dropdown");

    //#region Single Salesforce Form Logic

    var singleSalesForceFormExists = document.getElementsByClassName('single-salesforce-form-wrapper');

    if (singleSalesForceFormExists.length > 0) {
        //looping through forms
        $.each(singleSalesForceFormExists, function (index, singleForm) {

            var guidValue = singleForm.getElementsByClassName("guid_value").item(0).value;
            var newLeadInputValue = singleForm.getElementsByClassName("new_lead_value").item(0).value;
            var campaignRefValue = singleForm.getElementsByClassName("campaign_ref_value").item(0).value;
            var eventName = singleForm.getElementsByClassName("campaign_ref_value").item(0).value;
            var launchLead = singleForm.getElementsByClassName("launch_lead_hidden_value").item(0).value;
            var newLeadInputValueTrimmed = newLeadInputValue.replace(" ", "").toLowerCase();

            //update respective modal value
            $('.' + guidValue + '-form-wrapper .sales-force-form input[name="form_modal_guid_value"]').val(guidValue);

            //updating leadsource
            if (newLeadInputValue != "") {
                $('.' + guidValue + '-form-wrapper .sales-force-form input[name="LeadSource"]').val(newLeadInputValue);
            }

            if (newLeadInputValueTrimmed == "liveevent") {
                var eventNameInput = '<input type="hidden" hidden class="event_name__value" name="Event_Name__c" value="' + eventName + '" />';
                $('.' + guidValue + '-form-wrapper .sales-force-form').append(eventNameInput);
            }

            if (launchLead != "") {
                var launchLeadInput = '<input type="hidden" hidden class="Launch__c" name="Launch__c" value="' + launchLead + '" />';
                $('.' + guidValue + '-form-wrapper .sales-force-form').append(launchLeadInput);
            }
            if (campaignRefValue != "") {
                var campaignRefInput = '<input type="hidden" hidden class="campaign__ref__value" name="Campaign_Ref__c" value="' + campaignRefValue + '" />';
                $('.' + guidValue + '-form-wrapper .sales-force-form').append(campaignRefInput);
            }
        });

    }
    //#endregion
});

window.formvalidcheck = formvalidcheck;
